import { css } from 'styled-components';
import brand from './brand';
export default css `
  &::-webkit-scrollbar-track {
    background-color: ${brand.grey.grey40};
  }

  &::-webkit-scrollbar {
    background-color: ${brand.grey.grey40};
    height: 6px;
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${brand.primary.base};
    border-radius: 0;
    cursor: pointer;
  }
`;
